import { render } from "./Parameters_1.vue?vue&type=template&id=49407fbe&scoped=true"
import script from "./Parameters_1.vue?vue&type=script&lang=js"
export * from "./Parameters_1.vue?vue&type=script&lang=js"

import "./Parameters_1.vue?vue&type=style&index=0&id=49407fbe&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49407fbe"]])

export default __exports__